var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scissors-layout"},[_c('app-mobile-menu'),_c('app-header'),_c('transition',{attrs:{"name":"fade-page","mode":"out-in"}},[_c(_vm.page,{tag:"component"})],1),_c('app-footer'),_c('app-lightbox'),_c('app-notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }